import moment from 'moment'

/**
 * amendReps
 *
 * Applies regression and progression logic
 * to a workout_exercise.
 *
 * @param {*} exercise
 * @param Moment workoutStart
 * @param Moment currentDate
 * @returns Promise
 */
export default function (exercise, workoutStart, currentDate, freshStarter = false) {
  return new Promise(resolve => {
    let amendedAmount = 0

    // No need to amend anything
    if (!exercise.regression && !exercise.progression) {
      return resolve(exercise)
    }

    let diffInDays = moment(currentDate).diff(workoutStart, 'days')
    let diffWeeksRounded = Math.trunc(diffInDays / 7)
    let weeklyIncrement = exercise.week_increment ? exercise.week_increment : 1

    if (!freshStarter) {
      amendedAmount = Math.floor((diffWeeksRounded / weeklyIncrement))
    }

    // Amend for fresh starters
    if (freshStarter) {
      switch (diffWeeksRounded) {
        case 2:
        case 6:
        case 10:
          amendedAmount = 2
          break
        case 3:
        case 7:
        case 11:
          amendedAmount = 3
          break
        case 4:
        case 8:
        case 12:
          amendedAmount = 4
          break
        default:
          break
      }
    }

    if (exercise.regression) {
      exercise.reps = parseInt(exercise.reps, 10) - amendedAmount
    }
    if (exercise.progression) {
      exercise.reps = parseInt(exercise.reps, 10) + amendedAmount
    }

    return resolve(exercise)
  })
}



// WEBPACK FOOTER //
// ./src/utils/amendReps.js